import React, { Component } from 'react';
import {
  Link,
} from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Logo from './assets/logo-2.svg';

class Navigation extends Component {

  state = {
    isActive: false,
  }

  toggleNav = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive
    }))
  }

  render() {
    return (
      <nav className="navbar">
        <div className="navbar-brand">
          <div className="navbar-item logo">
            <Link to="/">
              <img
              src= { Logo }
              className="is-logo"
              />
              <h1 className="title has-text-white is-size-4 is-logo-word">
                Howler AI
              </h1>
            </Link>
            <p className="two">4.0</p>
          </div>
          <div className="navbar-burger burger" onClick={this.toggleNav}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div className={ this.state.isActive ? 'navbar-menu is-active' : 'navbar-menu'}>
          <div className="navbar-end">
            <div className="navbar-item">
              <div className={ this.state.isActive ? 'field' : 'field is-grouped'}>
                <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                  <AnchorLink href="#FAQ" className={ this.state.isActive ? 'button is-light' : 'button is-clear'}>FAQ</AnchorLink>
                </p>
                <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                  <Link to="/pricing" className={ this.state.isActive ? 'button is-light' : 'button is-clear'}>Pricing</Link>
                </p>
                <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                  <Link to="/pricing" className={ this.state.isActive ? 'button is-primary' : 'button is-white'}>Subscribe now</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/navigation.js